import Disclosures, { disclosureTypes } from './disclosures/Disclosures';
import LoanPurpose from './loan-purpose/LoanPurpose';
import HomeOwnership from './home-ownership/HomeOwnership';
import Address from './address/Address';
import FirstName from './first-name/FirstName';
import LastName from './last-name/LastName';
import Recaptcha from './recaptcha/Recaptcha';
import DeviceFingerprint from './device-fingerprint/DeviceFingerprint';
import EmploymentStatus from './employment-status/EmploymentStatus';
import SSNLast4 from './ssn-last4/SSNLast4';
import ContinueButton from './continue-button/ContinueButton';
import Password from './password/Password';

const components = {
    disclosures: {
        Disclosures,
        disclosureTypes,
    },
    LoanPurpose,
    HomeOwnership,
    Address,
    FirstName,
    LastName,
    Recaptcha,
    EmploymentStatus,
    SSNLast4,
    DeviceFingerprint,
    ContinueButton,
    Password,
};

export default components;
